import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", {
        class: "font7-responsive pointerhover",
        title: "Einen Schritt zurück",
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.stepBackLink && _ctx.stepBackLink(...args)))
    }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { style: { "text-decoration": "none !important" } }, "←", -1),
            _createElementVNode("span", { class: "link-in-text" }, "Zurück", -1)
        ]))]));
}
